import React from "react";
import { SnackbarContent, CustomContentProps } from "notistack";
import { AlertTriangle } from "lucide-react";

const CustomWarningSnackbar = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {
  const { message, id, ...other } = props;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <SnackbarContent
        ref={ref}
        id={id?.toString()}
        {...other}
        style={{
          backgroundColor: "white",
          color: "black",
          padding: "16px 20px",
          fontSize: "1rem",
          fontWeight: "500",
          lineHeight: "1.5",
          fontFamily: "var(--font-sans)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          width: "fit-content",
          minWidth: "unset",
          maxWidth: "unset",
        }}
      >
        <div
          style={{
            backgroundColor: "hsl(var(--warning))",
            color: "white",
            borderRadius: "50%",
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
            fontWeight: "bold",
            marginRight: "12px",
            animation: "iconBounce 0.6s ease-out",
          }}
        >
          <AlertTriangle size={16} />
        </div>
        {message}
      </SnackbarContent>
    </div>
  );
});

CustomWarningSnackbar.displayName = "CustomWarningSnackbar";

export default CustomWarningSnackbar;
